import { buildColMeta, useTableSearch } from '@/components/custom/erp/data-table-v2';
import { DATA_TABLE_BASE_COLS } from '../cols-definition';
import { SearchFormValues } from '../schema';
import { QUERY_KEYS } from '@/constants';

interface UseSearchTableProps {
  searchData: (filters: Record<string, MuaHangRecord>, page?: number, searchPageSize?: number) => Promise<void>;
  searchParams: SearchFormValues;
  setSearchParams: (params: SearchFormValues) => void;
  isFiltered: boolean;
  handlePageChange: (page: number) => Promise<void>;
}

export const useSearchTable = ({
  searchData,
  searchParams,
  setSearchParams,
  isFiltered,
  handlePageChange
}: UseSearchTableProps) => {
  return useTableSearch<SearchFormValues>({
    endpoint: `${QUERY_KEYS.HOA_DON_MUA_DICH_VU}/filter`,
    pageSize: 20,
    sumField: 't_tien',
    searchData,
    searchParams,
    setSearchParams,
    isFiltered,
    handlePageChange,
    getColumnMeta: () => buildColMeta(DATA_TABLE_BASE_COLS)
  });
};
